import React, { useEffect, useState } from "react";
import { Col, Card, Row, Form } from "react-bootstrap";
import FieldSelector from "../../../customComponents/FieldSelector";
import { useFormik } from "formik";
import * as yup from "yup";
import API from "../../../../api/api";
import { useToast } from "../../../../contexts/toast";
import { parsedUser } from "../../../../utils/GetCurrentUser";
import SPECIALRATEFIELDS from "../../Fields/RatePeriodSpecialRateFields";
import yupTypeValidator from "../../../../utils/YupTypeValidator";

import { useTranslation } from "react-i18next";

const SpecialRateGeneral = (props) => {
  const { t } = useTranslation();
  const [validationsSchema, setValidationSchema] = useState(null);
  const updateField = (fieldName, fieldValue) => {
    formik.setFieldValue(fieldName, fieldValue);
  };
  const user = parsedUser();
  const toast = useToast();

  const selectedItem = props.selectedItem;
  const actionMode = props.actionMode;
  //This method is to save the record we are working on
  const handleSubmit = async (values, event) => {
    try {
      let objSPVersion = `@GUIDContract='${props.contractGUID}'`;
      fields.forEach((item) => {
        if (item.HtmlType === "separator") return;

        if (item.HtmlType !== "separator") {
          objSPVersion +=
            (objSPVersion.length > 0 ? ", " : "") + `@${item.FieldName}=`;
        }
        if (
          item.FieldType === "int" ||
          item.FieldType === "bool" ||
          item.FieldType === "bit" ||
          item.FieldType === "bigint" ||
          item.FieldType === "money"
        ) {
          objSPVersion +=
            values[item.FieldName] === undefined ||
            values[item.FieldName] === null
              ? item.DefaultValue && item.DefaultValue > 0
                ? item.DefaultValue
                : "null"
              : values[item.FieldName];
        } else if (item.HtmlType === "radio") {
          objSPVersion +=
            values[item.FieldName] === undefined ||
            values[item.FieldName] === null
              ? item.DefaultValue && item.DefaultValue.length > 0
                ? item.DefaultValue
                : "null"
              : "'" + values[item.FieldName] + "'";
        } else {
          objSPVersion +=
            values[item.FieldName] === undefined ||
            values[item.FieldName] === null
              ? "null"
              : "'" + values[item.FieldName] + "'";
        }
      });

      let queryString = `IdUser=${user.IdUser}&Token=${user.Token}&ActionMode=${actionMode}`;

      let queryData = {
        Data: objSPVersion,
      };

      let request = await API.postAction(
        "api/contracts/SpecialRateAddEdit" + "?" + queryString,
        queryData
      );

      if (request.status === 200) {
        let response = JSON.parse(request.data[0].JSONData)[0];
        if (response.Error) {
          //	setGeneralError(response.Msg);
          return;
        }
        console.log(response.JSONData);
        props.setSelectedITem(response.JSONData);
      }
      toast({
        type: "success",
        message: "Registro guardado correctamente",
      });

      props.setStep(props.step + 1);
      props.setActionMode("U");

      //	toggleOpen(null, true);
    } catch (error) {
      console.error(error);
    } finally {
      props.setRequestSubmitGeneral(false);
    }
  };
  const formik = useFormik({
    initialValues: {},
    // enableReinitialize: true,
    validateOnChange: false,
    // validateOnBlur: false,
    validationSchema: validationsSchema,

    onSubmit: handleSubmit,
  });
  const fillFormikObject = (record) => {
    console.log(record);
    if (record && fields && fields.length > 0) {
      fields.forEach((item) => {
        console.log(
          "field name",
          item.FieldName,
          "RecordValue ",
          record[item.FieldName]
        );
        formik.setFieldValue(item.FieldName, record[item.FieldName]);
      });
    }

    //Now
  };

  // Prepare Formik Object
  const prepareFormikObject = () => {
    console.log("Preparing formik object", fields);
    let initialObject = {};
    let initialObjectValidation = {};

    if (fields) {
      fields.forEach((item) => {
        initialObject[item.FieldName] = item.value;

        if (item.Required) {
          initialObjectValidation[item.FieldName] = yupTypeValidator(item);
        }
      });
    }
    console.log("formik initial value", initialObject);
    formik.initialValues = initialObject;

    setValidationSchema(yup.object(initialObjectValidation));
  };

  const [fields, setFields] = useState(SPECIALRATEFIELDS);
  useEffect(() => {
    fillFormikObject(props.selectedItem);
  }, [props.selectedItem]);
  useEffect(() => {
    console.log(props);

    if (props.requestSubmitGeneral) {
      formik.submitForm();
    }
  }, [props.requestSubmitGeneral]);
  useEffect(() => {
    prepareFormikObject();
  }, []);
  return (
    <Card>
      <Card.Body>
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            {fields.map((item, index) => (
              <Col
                className={item.cssClasss + (!item.Visible ? " d-none" : "")}
                key={index}
              >
                <label className="me-2 mt-2">{t(item.FieldTitle)}</label>
                {item.Required ? (
                  <i className="required-asterisk ms-1 text-danger">*</i>
                ) : null}
                <br />

                <FieldSelector
                  section="SpecialRate"
                  sectionReferenceContent={props.Contract}
                  actionMode={props.actionMode}
                  model={item}
                  key={index}
                  obj={formik.values}
                  updateField={updateField}
                  value={formik.values[item.FieldName]}
                ></FieldSelector>
                {formik.errors[item.FieldName] ? (
                  <div className="invalid text-sm">
                    {formik.errors[item.FieldName]}
                  </div>
                ) : null}
              </Col>
            ))}
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default SpecialRateGeneral;
